var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36133 12.5224L13.3434 12.4916C15.3084 12.4793 16.8945 10.1587 16.8861 7.30822C16.8859 7.24942 16.8851 7.19086 16.8835 7.13255M16.8835 7.13255L2 7.22477M16.8835 7.13255L20.4739 7.1103M16.8835 7.13255C16.8115 4.36378 15.2374 2.15706 13.3129 2.16899L5.57193 2.21698",
    stroke: "#327967",
    strokeWidth: 2.61044,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarIconLogo);
export default __webpack_public_path__ + "static/media/Navbar_icon_logo.b989de5a52739be623e910b9890a620a.svg";
export { ForwardRef as ReactComponent };